<div class="page-title-container">
    @if (breadcrumbs().length > 1) {
        <nz-breadcrumb>
            @for (breadcrumb of breadcrumbs(); track breadcrumb) {
                <nz-breadcrumb-item [routerLink]="breadcrumb.path ? [`${breadcrumb.path}`] : null">
                    {{breadcrumb.label | translate}}
                </nz-breadcrumb-item>
            }
        </nz-breadcrumb>
    }
      <h2>
        {{ pageTitle() | translate }}
        @if(documentId()) {
            <span style="margin-left: 8px;" class="documentId-text">{{'GLOBAL.DOC-IDENTIFIER' | translate}}</span>
            <span style="margin-left: 4px;" class="documentId-text">{{documentId()}}</span>
        }
      </h2>
</div>

